import { render, staticRenderFns } from "./CatalogData.vue?vue&type=template&id=cc2fdb92&scoped=true"
import script from "./CatalogData.vue?vue&type=script&lang=js"
export * from "./CatalogData.vue?vue&type=script&lang=js"
import style0 from "./CatalogData.vue?vue&type=style&index=0&id=cc2fdb92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2fdb92",
  null
  
)

export default component.exports